export default __webpack_public_path__ + "static/disinfezione-2159da2aa8e075e3b2a7c6165b5493fd.png";